import { SocialMediaType } from "@components/Button/utils/types";
import { appDownloadLinks } from "@components/Footer/utils/constant";
import { IconTypeEnum } from "@components/Icon/utils/types";
import ArticleAllToolPopover from "@features/toolbar/ArticleToolbar/components/ArticleAllToolPopover";
import ArticleAppBannerButton from "@features/toolbar/ArticleToolbar/components/ArticleAppBannerButton";
import ArticleGooglePreferedSourceButton from "@features/toolbar/ArticleToolbar/components/ArticleGooglePreferedSourceButton";
import ArticleShareToolPopover from "@features/toolbar/ArticleToolbar/components/ArticleShareToolPopover";
import ArticleSummariseButton from "@features/toolbar/ArticleToolbar/components/ArticleSummarise";
import ArticleSubshare from "@pages/Article/components/ArticleSubshare/ArticleSubshare";

export const BUTTON_CSS =
  "m-0 w-full items-center justify-between gap-3 rounded-none px-4 lg:px-6 text-sm font-normal hover:bg-gray-250 lg:flex-row-reverse lg:justify-end border-none lg:text-2xs lg:font-semibold min-h-[42px] py-2 !no-underline";

export const SHARE_PANEL_LIST = [
  {
    text: "Share on WhatsApp",
    whichSocialMedia: SocialMediaType.whatsapp,
    icon: IconTypeEnum.whatsapp,
  },
  {
    text: "Share by Email",
    whichSocialMedia: SocialMediaType.email,
    icon: IconTypeEnum.emailV3,
  },
  {
    text: "Share on X",
    whichSocialMedia: SocialMediaType.twitter,
    icon: IconTypeEnum.twitter,
  },
  {
    text: "Share on Telegram",
    whichSocialMedia: SocialMediaType.telegram,
    icon: IconTypeEnum.telegram,
  },
  {
    text: "Share on Facebook",
    whichSocialMedia: SocialMediaType.facebook,
    icon: IconTypeEnum.facebook,
  },
  {
    text: "Share on LinkedIn",
    whichSocialMedia: SocialMediaType.linkedin,
    icon: IconTypeEnum.linkedin,
  },
];

export const APP_DOWNLOAD_LINKS = [
  appDownloadLinks.ios,
  appDownloadLinks.google,
];

export const TRACKING_OBJECT = {
  listen: {
    event: "custom_event",
    eventCategory: "tts",
    eventAction: "click",
    eventLabel: "listen to this article",
  },
  share: {
    event: "custom_event",
    eventCategory: "share article",
    eventAction: "click share",
  },
  socialShare: {
    event: "custom_event",
    eventCategory: "share article",
  },
  bookmark: {
    event: "custom_event",
    eventCategory: "bookmark",
    eventAction: "click",
  },
  print: {
    event: "custom_event",
    eventCategory: "print the article",
    eventAction: "click",
  },
  reading: {
    event: "custom_event",
    eventCategory: "reading preferences",
    eventAction: "click",
  },
  feedback: {
    event: "custom_event",
    eventCategory: "feedback",
    eventAction: "click",
  },
  reuse: {
    event: "custom_event",
    eventCategory: "reuse this content",
    eventAction: "click",
  },
  google_prefered_source: {
    event: "preferred_source_cta_click",
    eventCategory: "preferred source on google",
    eventAction: "click",
  },
};

export const TOOLLIST_ARTICLE = [
  {
    Component: ArticleSummariseButton,
    icon: IconTypeEnum.play,
    testId: "article-summarise-button-component",
    trackingObject: TRACKING_OBJECT.listen,
    extraClass: "mr-0 px-3 lg:px-6",
  },
  {
    icon: IconTypeEnum.shareLine,
    Component: ArticleShareToolPopover,
    testId: "article-social-sharing-component",
    trackingObject: TRACKING_OBJECT.share,
    extraClass: "p-2 lg:px-6 lg:py-3 md:flex md:items-center",
    text: "Share",
  },
  {
    Component: ArticleSubshare,
    testId: "article-subshare-component",
    extraClass: "flex p-2 lg:p-3 mr-0 md:ml-auto",
  },
  {
    Component: ArticleAppBannerButton,
    icon: IconTypeEnum.bookmark,
    testId: "article-bookmark-button-component",
    isAlternative: true,
    trackingObject: TRACKING_OBJECT.bookmark,
    extraClass: "hidden xs:flex p-2 lg:p-3 ml-auto md:ml-0",
  },
  {
    Component: ArticleAllToolPopover,
    testId: "article-all-tool-component",
    extraClass: "aspect-square p-2 lg:p-3",
  },
  {
    Component: ArticleGooglePreferedSourceButton,
    testId: "article-google-prefered-source-button",
    extraClass: "p-2 lg:p-3 mr-0 md:ml-auto hidden md:flex",
    trackingObject: TRACKING_OBJECT.google_prefered_source,
    text: "Add BT as a preferred source",
  },
];

export const TOOLLIST_HEADER = [
  {
    icon: IconTypeEnum.shareLine,
    Component: ArticleShareToolPopover,
    testId: "article-social-sharing-component",
    text: "Share article",
    extraClass: "border-0 lg:border lg:px-6 py-2 max-h-[42px]",
    trackingObject: TRACKING_OBJECT.share,
  },
  {
    Component: ArticleAppBannerButton,
    icon: IconTypeEnum.playLine,
    testId: "article-listen-button-component",
    extraClass:
      "border-0 lg:border lg:hidden lg:border min-[1100px]:flex p-2 max-h-[42px]",
    trackingObject: TRACKING_OBJECT.listen,
  },
  {
    Component: ArticleSubshare,
    testId: "article-subshare-component",
    extraClass: "border-0 lg:border mr-0 p-2 max-h-[42px]",
  },
  {
    Component: ArticleAppBannerButton,
    icon: IconTypeEnum.bookmark,
    testId: "article-bookmark-button-component",
    extraClass:
      "border-0 lg:border lg:hidden lg:border min-[1100px]:flex p-2 max-h-[42px]",
    isAlternative: true,
    trackingObject: TRACKING_OBJECT.bookmark,
  },
  {
    Component: ArticleAllToolPopover,
    testId: "article-all-tool-component",
    extraClass: "border-0 lg:border p-2 max-h-[42px]",
  },
];

export const APP_BANNER_CONTENT = {
  bookmark: {
    title: "Download the BT App to bookmark this article",
    description: "Enjoy the best reading experience on the App.",
  },
  play: {
    title: "Download the BT App to listen to this article",
    description: "Enjoy the best reading experience on the App.",
  },
  playLine: {
    title: "Download the BT App to listen to this article",
    description: "Enjoy the best reading experience on the App.",
  },
  preferences: {
    title: "Download the BT App to change reading preferences",
    description: "Enjoy the best reading experience on the App.",
  },
};
